<preview-image
  *ngIf="exibirPopupImg && width > 480 && experiencia?.imagemSrc2"
  [imageUrl]="experiencia?.imagemSrc2"
  (closeModalEvent)="fecharPopup()"
></preview-image>

<preview-image
  *ngIf="exibirPopupImg && width <= 480 && experiencia?.imagemSrc3"
  [imageUrl]="experiencia?.imagemSrc3"
  (closeModalEvent)="fecharPopup()"
></preview-image>

<lovers-login-popup
  [exibir]="exibirModalLogin"
  [exibirBackground]="true"
  (onClose)="controlePopupLogin(false)"
  tamanho="auth"
  [blockOverflow]="true"
>
  <div class="auth__container">
    <div class="auth__form">
      <!-- <img src="assets/images/logos/cacaulovers.png" class="lovers__image" /> -->
      <app-entrar (irParaAcesso)="abrirCadastroPeloAcesso()" (idTipoStatus)="receberIdStatus($event)"
        (membroToken)="receberToken($event)" (irParaEsqueci)="abrirEsqueciMinhaSenhaPeloAcesso()"
        (enviarBloqueioPoup)="receberBloqueioPopup($event)" [redirectLink]="linkRedirect" [Urlreturn]="returnUrl"
        [etapaAtual]="etapaLogin"></app-entrar>
    </div>
    <div class="cadastro__imagem" *ngIf="!cadastroRealizado">
      <img class="imagem__popup" [src]="randomImageUrl" />
    </div>
  </div>
</lovers-login-popup>

<lovers-login-popup
  [exibir]="exibirModalEsqueciSenha"
  [exibirBackground]="true"
  (onClose)="controlePopupEsqueci(false)"
  tamanho="auth"
  [blockOverflow]="true"
>
  <div class="auth__container">
    <div class="auth__form">
      <app-esqueci-minha-senha
        (abrirAcesso)="abrirAcessoPeloEsqueci()"
        (enviado)="controlePopupEsqueci(false)"
      >
      </app-esqueci-minha-senha>
    </div>
    <div class="cadastro__imagem" *ngIf="!cadastroRealizado">
      <img class="imagem__popup" [src]="randomImageUrl" />
    </div>
  </div>
</lovers-login-popup>

<lovers-login-popup
  [exibir]="exibirModalCadastro"
  [exibirBackground]="true"
  (onClose)="controlePopupCadastro(false)"
  [blockOverflow]="true"
  tamanho="auth"
>
  <div
    class="auth__container container__cadastro"
    [ngClass]="{ 'auth--cadastrado': cadastroRealizado }"
  >
    <div class="auth__form">
      <app-cadastro
        (abrirModalDireto)="controlePopupCadastro(true)"
        (abrirAcesso)="abrirAcessoPeloCadastro()"
        (cadastroRealizado)="onCadastroRealizado()"
        (clickMudaImagem)="carregarImagemAleatoria()"
        [redirectLink]="linkRedirect"
        [idStatus]="idStatus"
        [token]="token"
      ></app-cadastro>
    </div>
    <div class="cadastro__imagem" *ngIf="!cadastroRealizado">
      <img class="imagem__popup" [src]="randomImageUrl" />
    </div>
  </div>
</lovers-login-popup>

<img
  id="go-to-top"
  src="assets/images/others/go_top.svg"
  class="go__top"
  (click)="irParaOTopo()"
/>

<!-- <img src="assets/images/logos/botao__coracao__promocao.png" (click)="irParaPaginaPromocoes()" class="valentine__button valentine__button__pulsar" loading="lazy" alt="Botão para página de namorados"> -->

<main id="lp-lovers" class="lp__lovers">
  <header class="lp__header">
    <div class="header__logo">
      <img src="assets/images/logos/cacaulovers.png" class="logo__image" />
    </div>
    <div class="header__sign">
      <button
        id="entrar"
        type="button"
        (click)="controlePopupLogin(true)"
        class="button__sign_in sign__in"
      >
        Entrar
      </button>
      <button
        id="cadastro"
        type="button"
        (click)="controlePopupCadastro(true)"
        class="button sign__on"
      >
        Faça já o seu cadastro!
      </button>
      <!-- <button type="button" (click)="irParaPaginaPromocoes()" class="participe__button">
        Promoção Namorados
      </button> -->
      <a href="https://www.cacaushow.com.br/" target="_blank">
        <img src="assets/images/logos/cs.png" class="sign__logo" />
      </a>
    </div>
  </header>

  <div class="contents__click click__left" (click)="previousStory()"></div>
  <div class="contents__click click__right" (click)="nextStory()"></div>

  <div class="lovers__carousel__contents" id="carousel-contents">
    <div class="keen-slider keen-slider--vertical" #sliderRef id="sliderRef">
      <div
        class="keen-slider__slide"
        *ngFor="let story of windowWidth > 860 ? stories : storiesMobile"
      >
        <img [src]="story" class="content__image img-carousel" />
      </div>
    </div>
    <div class="slider__controls">
      <div
        class="controls__control"
        *ngFor="let story of stories; let i = index"
        [ngClass]="{ control__checked: i <= currentSlide }"
        (click)="slider.moveToIdx(i)"
      ></div>
    </div>
  </div>

  <div class="background__trufa">
    <img
      *ngIf="windowWidth >= 767"
      src="assets/images/backgrounds/background_lp_trufas.png"
      alt=""
    />
    <img
      *ngIf="windowWidth < 767"
      src="assets/images/backgrounds/background_lp_trufas_mobile.png"
      alt=""
    />
  </div>

  <div class="counter__container">
    <div class="lovers__counter">
      <div
        id="container-somos"
        class="counter__we animation__speed__fast animation__down__up"
      >
        <p class="we__text">Somos</p>
      </div>

      <div
        id="container-value"
        class="counter__value animation__speed__normal animation__down__up"
      >
        <div class="value__container">
          <p
            class="value__total"
            *ngFor="let contador of quantidadeLovers; let i = index"
            [ngClass]="{
              'valor--separador': contador.tipo === 'separador',
              'valor--transform': i % 2 !== 0 && contador.tipo !== 'separador'
            }"
          >
            {{ contador.valor }}
          </p>
        </div>
        <p class="lovers__count">de</p>
        <img
          class="value__lovers"
          src="assets/images/logos/lovers_colored.svg"
        />
      </div>
    </div>
  </div>

  <div class="lovers__cta">
    <div class="cta__texts">
      <p
        id="cta-title"
        class="texts__title gradient__text animation__speed__fast animation__down__up"
      >
        Hey
        <img
          class="value__lovers"
          src="assets/images/logos/lover_colored.png"
        />,
      </p>
      <p
        id="cta-description-title"
        class="texts__description__title animation__speed__normal animation__down__up"
      >
        Que delícia saber que você também é apaixonado por chocolate.
      </p>
      <p
        id="cta-description"
        class="texts__description animation__speed__normal animation__down__up"
      >
        Cacau Lovers é o programa de fidelidade da Cacau Show que foi feito com
        muito carinho para transformar momentos comuns em momentos especiais.
      </p>
      <button
        id="cta-button"
        type="button"
        class="button animation__speed__fast animation__down__up"
        (click)="controlePopupCadastro(true)"
        *ngIf="!membro"
      >
        Faça já o seu cadastro!
      </button>
    </div>
  </div>

  <div class="background__trufa_2">
    <img
      *ngIf="windowWidth > 480"
      src="assets/images/backgrounds/background_lp_trufas_2.svg"
      alt=""
    />
    <img
      *ngIf="windowWidth <= 480"
      src="assets/images/backgrounds/background_lp_mobile.png"
      alt="Trufas"
    />
  </div>

  <div class="lovers__experiences">
    <p
      id="experiencias-title"
      class="experiences__title gradient__text animation__speed__normal animation__down__up"
    >
      Acumule Cacaus a cada compra e resgate <span>produtos</span> e
      <span>experiências</span>
    </p>

    <div class="experiences__carousel">
      <div
        class="keen-slider keen-slider--vertical"
        #sliderExperienciasRef
        id="sliderExperienciasRef"
        *ngIf="exibirCarouselExperiencias"
      >
        <div
          class="keen-slider__slide"
          *ngFor="let experiencia of experiencias; let index = index"
        >
          <div
            *ngFor="let exp of experiencia"
            class="experiencia__card"
            [ngClass]="{ slide__transform__up: index % 2 === 0 }"
          >
            <img [src]="exp.imagemSrc" class="card__image" />
            <div class="card__detalhes">
              <p class="detalhes__nome">{{ exp.nome }}</p>
              <p class="detalhes__categoria">
                {{ tratarCategorias(exp.idCategoria) }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="lovers__pela__causa">
    <div class="fundo__transparente">
      <div class="logos">
        <img
          class="logo__lovers"
          src="assets/images/logos/LogoPelacausa.png"
          alt="Logo Lovers"
        />
        <div class="instituto__container">
          <img
            class="logo__instituto"
            src="assets/images/logos/LogoInstituto.png"
            alt="Logo Instituto"
          />
          <p class="texto__instituto">
            Em parceria com o ICS, agora além de resgatar momentos especiais,
            você também pode contribuir e fazer parte de ações sociais e
            ambientais através dos seus Cacaus.
          </p>
        </div>
      </div>
      <div class="body__causa">
        <div class="slider">
          <div
            class="slide-track"
            [ngStyle]="{ width: 'calc(251px * ' + quantidadeCards + ')' }"
            [ngClass]="{ 'ajuste--track': windowWidth <= 480 }"
          >
            <div
              class="slide cards"
              (click)="abrirPopup(experiencia)"
              *ngFor="let experiencia of experienciasCausa"
            >
              <div class="header">
                <img
                  class="img__card"
                  [src]="experiencia.imagemSrc"
                  alt="Imagem do card"
                />
              </div>
              <div class="footer">
                <p class="titulo">{{ experiencia.nome }}</p>
                <p class="data">{{ formatarData(experiencia.dataFim) }}</p>
              </div>
            </div>
            <div
              class="slide cards"
              *ngFor="let experiencia of experienciasCausa"
            >
              <div class="header">
                <img
                  class="img__card"
                  [src]="experiencia.imagemSrc"
                  alt="Imagem do card"
                />
              </div>
              <div class="footer">
                <p class="titulo">{{ experiencia.nome }}</p>
                <p class="data">{{ formatarData(experiencia.dataFim) }}</p>
              </div>
            </div>
          </div>
        </div>
        <button (click)="irParaMomentosEspeciais()" class="button__causa">
          Apoie essa causa!
        </button>
        <p (click)="irParaPelaCausa()" class="todas_as_causas">
          Ver todas as ações sociais
        </p>
      </div>
    </div>
  </div>

  <div class="lovers__comments">
    <div class="comments__left">
      <img
        id="disposition-feliz-hoje"
        class="comments__feliz_hoje animation__speed__fast animation__down__up"
        src="assets/images/logos/momentos_especiais_lp.png"
        alt="Feliz Hoje"
      />
      <p
        id="disposition-title"
        class="comments__title animation__speed__fast animation__down__up"
      >
        Veja o que os Lovers estão falando dos seus momentos especiais.
      </p>
      <p
        id="disposition-description"
        class="comments__description animation__speed__normal animation__down__up"
      >
        Quer aparecer em nossas redes sociais? Compartilhe sua experiência
        marcando nosso instagram @cacaulovers e use as hashtags:
      </p>
      <div class="hashtag_redes">
        <img
          id="disposition-hashtag-2"
          src="assets/images/others/hasthag_lovers_2.png"
          alt="#CacauLovers"
          class="comments__hashtag animation__speed__normal animation__down__up"
        />
        <img
          id="disposition-hashtag"
          src="assets/images/others/hasthag_lovers.png"
          alt="#CacauLovers"
          class="comments__hashtag animation__speed__normal animation__down__up"
        />
      </div>
    </div>

    <div class="comments__right">
      <img
        id="comments"
        class="comment__image animation__speed__normal animation__down__up"
        *ngFor="
          let depoimento of windowWidth > 460 ? depoimentos : depoimentosMobile
        "
        [src]="depoimento"
      />
    </div>
  </div>

  <div class="background"></div>

  <div class="background__conclusion">
    <img
      *ngIf="windowWidth > 460"
      src="../../../../assets/images/backgrounds/background__conclusion__chocolate.svg"
      alt=""
    />
    <img
      *ngIf="windowWidth <= 460"
      src="../../../../assets/images/backgrounds/background__conclusion__mobile.png"
      alt=""
    />
  </div>
  <div class="conclusion__container">
    <div class="lovers__conclusion">
      <p
        id="conclusion-text"
        class="conclusion__text animation__speed__fast animation__down__up"
      >
        Os benefícios que os
        <img
          class="conclusion__text__logo"
          src="assets/images/logos/cacaulovers.svg"
        />
        amam!
      </p>
      <p
        id="conclusion-description"
        class="conclusion__subtext animation__speed__normal animation__down__up"
      >
        Aproveite um mimo no seu aniversário e vantagens exclusivas em diversos
        parceiros.
      </p>
    </div>
    <div class="conclusion__beneficios">
      <div class="beneficio__card">
        <div class="tag__card">
          <img
            src="assets/images/others/exclusividades.png"
            id="destaque-1"
            alt="Destaque"
            class="destaque-beneficio"
          />
        </div>
        <img
          id="beneficios-1"
          src="assets/images/beneficios/hotel.svg"
          class="beneficios__beneficio animation__speed__fast animation__down__up"
        />
        <p>
          Early Check-in/ Late Check-out e Welcome Drink no Hotel Bendito Cacao
        </p>
      </div>
      <div class="beneficio__card">
        <div class="tag__card">
          <img
            src="assets/images/others/aniversario.png"
            id="destaque-1"
            alt="Destaque"
            class="destaque-beneficio"
          />
        </div>
        <img
          id="beneficios-2"
          src="assets/images/beneficios/comendo_trufa.png"
          class="beneficios__beneficio animation__speed__normal animation__down__up"
        />
        <p>Ganhe 1 chocolate Cacau Show de presente no seu aniversário</p>
      </div>
      <!-- <div class="beneficio__card">
        <div class="tag__card">
          <img
            src="assets/images/others/descontos.png"
            id="destaque-1"
            alt="Destaque"
            class="destaque-beneficio"
          />
        </div>
        <img
          id="beneficios-3"
          src="assets/images/beneficios/brigaderia.png"
          class="beneficios__beneficio animation__speed__slow animation__down__up"
        />
        <p>10% OFF em compras na Brigaderia</p>
      </div> -->
    </div>
    <button
      id="conclusion-button"
      class="button animation__speed__fast animation__down__up"
      (click)="controlePopupCadastro(true)"
      *ngIf="!membro"
    >
      Faça já o seu cadastro
    </button>
  </div>
  <div class="redes__sociais__app" *ngIf="appOnly">
    <div class="rede__social">
      <a
        href="https://www.facebook.com/CacauShow"
        target="_blank"
        title="Facebook"
      >
        <i class="fa fa-facebook-f fa-2x"></i>
      </a>
    </div>
    <div class="rede__social">
      <a href="https://www.instagram.com/cacauloverscs" target="_blank" title="Instagram">
        <i class="fa fa-instagram fa-2x"></i>
      </a>
    </div>
    <div class="rede__social">
      <a
        href="https://www.youtube.com/user/CacauShowBR"
        target="_blank"
        title="Youtube"
      >
        <i class="fa fa-youtube-play fa-2x"></i>
      </a>
    </div>
    <div class="rede__social">
      <a
        href="https://www.tiktok.com/@cacaushow?is_from_webapp=1&sender_device=pc"
        target="_blank"
        title="TikTok"
      >
        <img src="../../../../../assets/images/icons/tiktok.png" alt="" />
      </a>
    </div>
  </div>
  <img
    class="feliz__hoje"
    src="assets/images/logos/feliz_hoje.png"
    alt="Feliz Hoje"
  />

  <!-- <div class="lovers__image__footer">
    <div class="footer__gradient"></div>
    <img src="assets/images/backgrounds/footer2.png" class="footer__image" />
    <div class="footer__gradient__black"></div>
  </div> -->
</main>

<!-- <div class="space"></div>
<p id="teste1" class="x animation__fast">landing-page works!</p>
<p id="teste2" class="x animation__normal">XYZ@U!#U DJADJISJ!</p>
<div class="space"></div> -->